/*
 * df-search.js — Buscador predictivo del df-search-modal.
 * Conecta el modal con /search/suggest.json y gestiona resultados visuales.
 */
(function () {
  'use strict';

  var RECENT_KEY = 'df_search_recents';
  var MAX_RECENT = 5;
  var DEBOUNCE_MS = 200;
  var MAX_COLLECTIONS = 2;
  var MAX_PAGES = 3;
  var MAX_ANSWERS = 2;

  // Páginas que existen pero no son un destino para quien busca un regalo:
  // las versiones en portugués, las «Track your order» en inglés que dejó una
  // app, los textos legales de GDPR y compañía, y las comparativas con la
  // competencia, que son para Google, no para el cliente que ya está dentro.
  var PAGE_SKIP = /(portugal|^track-your-order|gdpr|privacy|pipeda|lgpd|appi|ccpa|^cookies$|^contact$|^dondefue-vs-|^comparativa-)/;
  // Las herramientas (calculadoras, generadores, tests) son la mitad del
  // tráfico de la web, pero no son lo que busca quien escribe «cuadro
  // pareja». Se quedan, detrás de las landings, salvo que las pidas.
  var PAGE_TOOL = /^(calculadora|generador|test-|coordenadas-decimales|quiz)/;
  // «compatibilidad» es la búsqueda número uno de la tienda (90 días a
  // 15-10-2026) y lo que quiere es el test de pareja: sin ella aquí, el test
  // salía detrás de las landings.
  var WANTS_TOOL = /calcul|generador|test|quiz|coordenad|compatib/;

  // Lo que no sale nunca en el buscador: el papel de regalo (se decide en la
  // cesta, no buscándolo) y cualquier cosa agotada.
  var HIDDEN_HANDLES = ['gift-wrap'];
  function isListable(p) {
    if (!p) return false;
    if (HIDDEN_HANDLES.indexOf(p.handle) !== -1) return false;
    return p.available !== false;
  }

  var modal, input, clearBtn, defaults, results, body;
  var productsGroup, productsList, productsCount;
  var collectionsGroup, collectionsList;
  var pagesGroup, pagesList;
  var loadingEl, emptyEl, seeAllEl, seeAllLink;
  var emptyQ, emptyFull, emptyTop, topList;
  var answersGroup, answerCards;
  var recentGroup, recentChips;
  var intents = [];

  // Lo que había en pantalla en el pintado anterior, por grupo. Sirve para
  // animar solo lo que entra nuevo: si «novi» y «novia» traen tres fichas
  // en común, esas tres se quedan quietas y solo suben las otras. Animarlo
  // todo a cada tecla era un parpadeo.
  var shown = { collections: {}, products: {}, pages: {} };
  var lastApiCollections = [];
  var skelTimer = null;
  var SKELETON_DELAY = 300;

  var currentTimer = null;
  var currentQuery = '';
  var trackedQuery = '';
  var lastAbort = null;

  function init() {
    modal = document.getElementById('df-search-modal');
    if (!modal) return;

    input = modal.querySelector('[data-df-search-input]');
    clearBtn = modal.querySelector('[data-df-search-clear]');
    defaults = modal.querySelector('[data-df-search-defaults]');
    results = modal.querySelector('[data-df-search-results]');
    body = modal.querySelector('[data-df-search-body]');

    productsGroup = modal.querySelector('[data-df-search-products-group]');
    productsList = modal.querySelector('[data-df-search-products]');
    productsCount = modal.querySelector('[data-df-search-products-count]');
    collectionsGroup = modal.querySelector('[data-df-search-collections-group]');
    collectionsList = modal.querySelector('[data-df-search-collections]');
    pagesGroup = modal.querySelector('[data-df-search-pages-group]');
    pagesList = modal.querySelector('[data-df-search-pages]');

    loadingEl = modal.querySelector('[data-df-search-loading]');
    emptyEl = modal.querySelector('[data-df-search-empty]');
    seeAllEl = modal.querySelector('[data-df-search-see-all]');
    seeAllLink = modal.querySelector('[data-df-search-see-all-link]');
    emptyQ = modal.querySelector('[data-df-search-empty-q]');
    emptyFull = modal.querySelector('[data-df-search-empty-full]');
    emptyTop = modal.querySelector('[data-df-search-empty-top]');
    topList = modal.querySelector('.df-search-modal__products--top');

    answersGroup = modal.querySelector('[data-df-search-answers-group]');
    answerCards = answersGroup ? Array.prototype.slice.call(answersGroup.querySelectorAll('[data-df-answer]')) : [];

    recentGroup = modal.querySelector('[data-df-search-recent-group]');
    recentChips = modal.querySelector('[data-df-search-recents]');

    intents = parseIntents(modal.getAttribute('data-df-search-intents'));

    if (!input) return;

    renderRecents();

    // Input
    input.addEventListener('input', onInputChange);
    input.addEventListener('keydown', onKeyDown);

    // Clear button
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        input.focus();
        onInputChange();
      });
    }

    // Suggest chips (top + recents)
    modal.addEventListener('click', function (e) {
      var sug = e.target.closest('[data-df-search-suggest]');
      if (sug) {
        input.value = sug.getAttribute('data-df-search-suggest');
        input.focus();
        onInputChange();
        return;
      }

      // Por que «Recientes» no salia nunca
      // ---------------------------------
      // La busqueda solo se guardaba en el `submit` del formulario, es decir,
      // solo si pulsabas Enter y te ibas a /search. Pero el buscador
      // predictivo esta hecho justo para lo contrario: escribes, ves la ficha
      // y la tocas. Ese camino —el de la inmensa mayoria, y practicamente el
      // unico en movil, donde el teclado no ensena ningun Enter evidente— no
      // guardaba nada. De ahi que el grupo naciera `hidden` y se quedara
      // asi para siempre: no es que no se pintara, es que no habia nada que
      // pintar.
      //
      // Se guarda al NAVEGAR desde un resultado, que es cuando la busqueda ha
      // servido para algo. Un termino que no llevo a ninguna parte no merece
      // volver a salir.
      var hit = e.target.closest('[data-df-search-result], [data-df-search-see-all-link], [data-df-search-empty-full]');
      if (hit) help.clicked = true;
      if (hit && currentQuery) {
        saveRecent(currentQuery);
        // Y se mide aquí también. Antes el evento `search` solo salía al
        // pulsar Enter, que es el camino minoritario: lo que la gente busca
        // y encuentra desde el desplegable no llegaba a ninguna analítica.
        if (trackedQuery !== currentQuery) {
          trackedQuery = currentQuery;
          trackSearch(currentQuery);
        }
      }
    });

    // Clear recents
    var clearRecent = modal.querySelector('[data-df-search-clear-recent]');
    if (clearRecent) {
      clearRecent.addEventListener('click', function () {
        localStorage.removeItem(RECENT_KEY);
        renderRecents();
      });
    }

    // Form submit (Enter → /search?q=)
    var form = modal.querySelector('[data-df-search-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        var q = input.value.trim();
        if (q) {
          saveRecent(q);
          if (trackedQuery !== q) { trackedQuery = q; trackSearch(q); }
        }
        // Form action ya es /search, dejamos submit nativo
      });
    }

    // Reset state when modal opens (handled by dondefue.js, here we just observe)
    var mo = new MutationObserver(function () {
      if (modal.hidden) { helpReset(); return; }
      // Repintar las recientes cada vez que se abre, no solo al cargar la
      // pagina. Volver atras desde una ficha no siempre recarga —el bfcache
      // devuelve la pagina tal cual la dejaste— y sin esto la busqueda que
      // acabas de hacer no aparecia hasta la siguiente recarga completa.
      renderRecents();
      if (document.activeElement !== input) {
        setTimeout(function () { input && input.focus(); }, 80);
      }
    });
    mo.observe(modal, { attributes: true, attributeFilter: ['hidden'] });
  }

  function onInputChange() {
    var q = input.value.trim();
    currentQuery = q;
    if (clearBtn) clearBtn.hidden = !q;

    if (currentTimer) clearTimeout(currentTimer);
    helpOnInput();

    if (!q) {
      showDefaults();
      return;
    }

    currentTimer = setTimeout(function () { runSearch(q); }, DEBOUNCE_MS);
  }

  function showDefaults() {
    stopLoading();
    defaults.hidden = false;
    results.hidden = true;
    // Se vacía lo de la búsqueda anterior: si no, al escribir otra cosa se
    // vería medio segundo lo de antes mientras carga lo nuevo.
    productsList.innerHTML = '';
    pagesList.innerHTML = '';
    collectionsList.innerHTML = '';
    productsGroup.hidden = true;
    pagesGroup.hidden = true;
    collectionsGroup.hidden = true;
    emptyEl.hidden = true;
    seeAllEl.hidden = true;
    shown = { collections: {}, products: {}, pages: {} };
    lastApiCollections = [];
    helpHide();
    renderRecents();
  }

  function showResults() {
    defaults.hidden = true;
    results.hidden = false;
  }

  // Mientras busca, lo de antes se queda (un poco apagado) y una línea roja
  // recorre el borde del campo. Antes cada tecla vaciaba la lista y ponía
  // tres bloques grises: la pantalla parpadeaba aunque la respuesta tardara
  // 80 ms. Los grises siguen, pero solo si no hay nada que enseñar y la
  // búsqueda pasa de 300 ms.
  function showLoading(q) {
    showResults();
    modal.classList.add('is-searching');
    // La respuesta rápida y la colección no dependen de la red: salen en la
    // misma tecla, mientras los productos cargan debajo.
    renderAnswers(q);
    renderCollections(q, lastApiCollections);
    clearTimeout(skelTimer);
    skelTimer = setTimeout(function () {
      if (!modal.classList.contains('is-searching') || !productsGroup.hidden) return;
      loadingEl.hidden = false;
      emptyEl.hidden = true;
      seeAllEl.hidden = true;
    }, SKELETON_DELAY);
  }

  function stopLoading() {
    clearTimeout(skelTimer);
    modal.classList.remove('is-searching');
    loadingEl.hidden = true;
  }

  // Marca como nueva la fila que no estaba en el pintado anterior del mismo
  // grupo. El índice escalona la entrada (30 ms por fila, tope en ocho: una
  // cascada más larga ya se lee como lentitud).
  function keyOf(url) { return String(url || '').split('?')[0]; }
  function tagEntry(el, key, prev, next, counter) {
    next[key] = true;
    if (prev[key]) return false;
    el.classList.add('is-new');
    el.style.setProperty('--df-i', String(Math.min(counter.n++, 8)));
    return true;
  }

  // === Spanish-friendly normalization & synonyms ===
  // Map accents → base letters
  function stripAccents(s) {
    if (!s) return '';
    return s.normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  // «Regalo para mi NOVIA!» → ['regalo', 'para', 'mi', 'novia']. Sin tildes
  // ni signos, igual que las palabras de las reglas (ver df-search-match).
  function foldTokens(q) {
    return stripAccents(String(q || '')).toLowerCase().split(/[^a-z0-9]+/).filter(Boolean);
  }

  // Misma sintaxis que `snippets/df-search-match.liquid`: `novia` es la
  // palabra entera, `cumple*` un prefijo y `casa+nueva` una frase.
  // Una diferencia a propósito: aquí se escribe letra a letra, así que la
  // última palabra, si ya tiene cuatro letras, también vale a medias
  // («novi» ya ofrece parejas). La página de resultados recibe la búsqueda
  // entera y no la necesita.
  function matchWords(words, tokens) {
    if (!words || !tokens.length) return false;
    var norm = ' ' + tokens.join(' ') + ' ';
    var last = tokens[tokens.length - 1];
    var list = words.split(/\s+/);
    for (var i = 0; i < list.length; i++) {
      var w = list[i];
      if (!w) continue;
      var isPrefix = w.charAt(w.length - 1) === '*';
      var ww = w.replace(/\*$/, '').replace(/\+/g, ' ');
      if (isPrefix ? norm.indexOf(' ' + ww) !== -1 : norm.indexOf(' ' + ww + ' ') !== -1) return true;
      if (last.length >= 4 && ww.indexOf(' ') === -1 && ww.length > last.length && ww.indexOf(last) === 0) return true;
    }
    return false;
  }

  function parseIntents(raw) {
    return String(raw || '').split('\n').map(function (line) {
      var parts = line.split('|');
      if (parts.length < 3) return null;
      return { handle: parts[0].trim(), label: parts[1].trim(), words: parts[2].trim() };
    }).filter(function (x) { return x && x.handle && x.words; });
  }

  function detectIntents(q) {
    var tokens = foldTokens(q);
    return intents.filter(function (it) { return matchWords(it.words, tokens); });
  }

  function renderAnswers(q) {
    if (!answersGroup) return 0;
    var tokens = foldTokens(q);
    var shown = 0;
    answerCards.forEach(function (card) {
      var on = shown < MAX_ANSWERS && matchWords(card.getAttribute('data-df-answer'), tokens);
      card.hidden = !on;
      if (on) shown++;
    });
    answersGroup.hidden = shown === 0;
    return shown;
  }

  // Colecciones: primero las de la intención («novia» → parejas), después las
  // que devuelva Shopify por título, sin repetir. Dos como mucho, que van
  // encima de los productos y no deben empujarlos fuera de la pantalla.
  function renderCollections(q, apiCollections) {
    var seen = {};
    var list = [];
    detectIntents(q).forEach(function (it) {
      if (seen[it.handle]) return;
      seen[it.handle] = true;
      list.push({ url: '/collections/' + it.handle, handle: it.handle, title: it.label, plain: true });
    });
    (apiCollections || []).forEach(function (c) {
      if (!c || seen[c.handle]) return;
      seen[c.handle] = true;
      list.push({ url: c.url, handle: c.handle, title: c.title });
    });
    list = list.slice(0, MAX_COLLECTIONS);

    var prev = shown.collections, next = {}, counter = { n: 0 };
    collectionsList.innerHTML = '';
    list.forEach(function (c) {
      var row = document.createElement('a');
      row.className = 'df-search-modal__row';
      row.setAttribute('data-df-search-result', '');
      row.href = c.url;
      row.innerHTML =
        '<span class="df-search-modal__coll-img" aria-hidden="true"></span>' +
        '<span class="df-search-modal__coll-text">' +
          '<span class="df-search-modal__coll-title">' + (c.plain ? escapeHtml(c.title) : highlight(c.title, q)) + '</span>' +
          '<span class="df-search-modal__coll-meta"></span>' +
        '</span>' + CHEVRON;
      tagEntry(row, keyOf(c.url), prev, next, counter);
      collectionsList.appendChild(row);
      fillCollectionMeta(row, c.handle);
    });
    shown.collections = next;
    collectionsGroup.hidden = list.length === 0;
    return list.length;
  }

  // La foto y el número de regalos de una colección salen de
  // `/collections/<handle>.json`, que la búsqueda predictiva no trae. Una
  // petición por colección y página: se guarda la promesa, así que escribir
  // «abuel», «abuelo», «abuelos» pide la misma una sola vez.
  var collMeta = {};
  function fillCollectionMeta(row, handle) {
    if (!handle || !window.fetch) return;
    if (!collMeta[handle]) {
      collMeta[handle] = fetch('/collections/' + encodeURIComponent(handle) + '.json', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { return (d && d.collection) || null; })
        .catch(function () { return null; });
    }
    collMeta[handle].then(function (c) {
      if (!c || !row.isConnected) return;
      var img = row.querySelector('.df-search-modal__coll-img');
      var meta = row.querySelector('.df-search-modal__coll-meta');
      if (img && c.image && c.image.src) {
        var src = c.image.src + (c.image.src.indexOf('?') === -1 ? '?' : '&') + 'width=120';
        img.style.backgroundImage = 'url("' + src.replace(/"/g, '%22') + '")';
      }
      if (meta && c.products_count) {
        meta.textContent = c.products_count + (c.products_count === 1 ? ' regalo' : ' regalos');
      }
    });
  }

  var CHEVRON = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 6 6 6-6 6"/></svg>';

  // Common Spanish synonym pairs (bidirectional)
  // If user types one, also try the other.
  var SYNONYMS = {
    'mama': ['mamá', 'madre'], 'mamá': ['mama', 'madre'], 'madre': ['mama', 'mamá'],
    'papa': ['papá', 'padre'], 'papá': ['papa', 'padre'], 'padre': ['papa', 'papá'],
    'cuadro': ['lámina', 'poster', 'lamina'], 'lamina': ['cuadro', 'lámina', 'poster'], 'lámina': ['cuadro', 'lamina', 'poster'],
    'poster': ['cuadro', 'lámina', 'lamina'], 'póster': ['cuadro', 'lámina'],
    'taza': ['mug', 'tazas', 'tazas mágicas', 'taza mágica'],
    'sudadera': ['hoodie', 'jersey'],
    'camiseta': ['tshirt', 't-shirt'],
    'pareja': ['novia', 'novio', 'esposa', 'esposo', 'love'],
    'novio': ['pareja', 'love'], 'novia': ['pareja', 'love'],
    'aniversario': ['aniversarios', 'love', 'pareja'],
    'cumpleanos': ['cumpleaños', 'cumple', 'bday'], 'cumpleaños': ['cumpleanos', 'cumple', 'bday'],
    'navidad': ['navidades', 'christmas'],
    'boda': ['bodas', 'wedding', 'casamiento'], 'bodas': ['boda', 'wedding'],
    'amigo': ['amigos', 'amigas', 'amig@'], 'amigos': ['amigo', 'amig@'],
    'nacimiento': ['bebé', 'bebe', 'recién nacido', 'baby'],
    'bebé': ['bebe', 'nacimiento', 'baby'],
    'bebe': ['bebé', 'nacimiento', 'baby'],
    'cancion': ['canción', 'songs'], 'canción': ['cancion'],
    'mapa': ['mapas', 'coordenadas', 'donde fue', 'localización', 'ciudad'],
    'foto': ['fotos', 'imagen', 'imágenes'],
    'regalo': ['regalos', 'gift', 'presente'],
    'corazon': ['corazón', 'love', 'amor'], 'corazón': ['corazon', 'love', 'amor'],
    'estelar': ['estrella', 'estrellas', 'cielo', 'mapa estelar'],
    'tio': ['tío', 'tía'], 'tia': ['tía', 'tío'],
    'abuelo': ['abuelos', 'abuela', 'yayo', 'yaya'],
    'abuela': ['abuelas', 'yaya', 'abuelo'],
    'hijo': ['hijos', 'hija', 'hijas'], 'hija': ['hijas', 'hijo'],
    'familia': ['familiar', 'familiares'],
    'personalizado': ['personalizada', 'personalizable', 'custom']
  };

  // `limit_scope=each`: sin él, el límite es para TODO junto. Con 6 y tres
  // tipos pedidos, Shopify devolvía 3 productos y 3 páginas, y como el papel
  // de regalo se oculta, «regalo novia» enseñaba 2 productos. Ahora el límite
  // es por tipo. Se pide uno de más porque el filtro de abajo (papel de
  // regalo, agotados, páginas que sobran) siempre se lleva alguno.
  function buildSuggestUrl(q, limit) {
    return '/search/suggest.json' +
      '?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection,page' +
      '&resources[limit]=' + Math.min(10, limit + 2) +
      '&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,product_type,variants.title,vendor,body,tag' +
      '&resources[options][prefix]=last';
  }

  function pickPages(pages, q) {
    var list = (pages || []).filter(function (p) { return p && !PAGE_SKIP.test(p.handle || ''); });
    if (!WANTS_TOOL.test(foldTokens(q).join(' '))) {
      var isTool = function (p) { return PAGE_TOOL.test(p.handle || ''); };
      list = list.filter(function (p) { return !isTool(p); }).concat(list.filter(isTool));
    }
    return list.slice(0, MAX_PAGES);
  }

  // Los títulos SEO de las landings llevan la marca al final
  // («… | Donde Fue», «… — Donde Fue»). Dentro de la propia tienda sobra.
  function cleanPageTitle(t) {
    return String(t || '').replace(/\s*[|—–-]\s*Donde Fue\s*$/i, '').trim();
  }

  function fetchOnce(url, signal) {
    return fetch(url, { signal: signal, headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function countResults(data) {
    var r = (data && data.resources && data.resources.results) || {};
    return (r.products || []).filter(isListable).length + (r.collections || []).length + pickPages(r.pages, '').length;
  }

  // Build alternative queries to try when exact yields nothing.
  function buildFallbackQueries(q) {
    var queries = [];
    var seen = {};
    function add(s) {
      var key = (s || '').toLowerCase().trim();
      if (!key || seen[key]) return;
      seen[key] = true;
      queries.push(s);
    }

    // 1. Accent-stripped
    var stripped = stripAccents(q);
    if (stripped !== q) add(stripped);

    // 2. Add accents (heuristic): try synonyms of each token
    var tokens = q.toLowerCase().split(/\s+/).filter(Boolean);
    var anySyn = false;
    var synTokens = tokens.map(function (t) {
      var bare = stripAccents(t);
      var syn = SYNONYMS[t] || SYNONYMS[bare];
      if (syn && syn.length) {
        anySyn = true;
        // First synonym substitutes
        return syn[0];
      }
      return t;
    });
    if (anySyn) add(synTokens.join(' '));

    // 3. Wildcard suffix (e.g. "regal" → "regal*")
    var lastToken = tokens[tokens.length - 1];
    if (lastToken && lastToken.length >= 3 && !/\*$/.test(lastToken)) {
      var wild = tokens.slice(0, -1).concat(lastToken + '*').join(' ');
      add(wild);
    }

    // 4. Single-token searches (each word independently) — broader OR
    if (tokens.length > 1) {
      tokens.forEach(function (t) {
        if (t.length >= 3) add(t);
      });
    }

    return queries;
  }

  function runSearch(q) {
    if (lastAbort) try { lastAbort.abort(); } catch (e) {}
    lastAbort = ('AbortController' in window) ? new AbortController() : null;

    showLoading(q);

    var limit = Number(window.dfSearchLimit || 6);

    // Strategy: try exact first, then fallback chain.
    var queries = [q].concat(buildFallbackQueries(q));
    var attemptIdx = 0;

    function tryNext() {
      if (attemptIdx >= queries.length) {
        // All strategies exhausted → render with intents fallback
        renderResults({ resources: { results: { products: [], collections: [], pages: [] } } }, q, /*usedFallback*/ true);
        return;
      }
      var candidate = queries[attemptIdx++];
      var url = buildSuggestUrl(candidate, limit);
      fetchOnce(url, lastAbort ? lastAbort.signal : undefined)
        .then(function (data) {
          if (q !== currentQuery) return; // race condition
          if (countResults(data) > 0) {
            renderResults(data, q, attemptIdx > 1);
          } else {
            tryNext();
          }
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          tryNext();
        });
    }
    tryNext();
  }

  function renderResults(data, q, usedFallback) {
    stopLoading();

    var limit = Number(window.dfSearchLimit || 6);
    var resources = (data && data.resources && data.resources.results) || {};
    var pages = pickPages(resources.pages, q);

    var nAnswers = renderAnswers(q);
    lastApiCollections = resources.collections || [];
    var nCollections = renderCollections(q, lastApiCollections);

    // Si la búsqueda era una pregunta («cuánto tarda el envío») y no pide
    // ningún tipo de regalo, los productos salen porque la palabra está en
    // su descripción, no porque vengan a cuento. Se quedan, pero tres.
    if (nAnswers && !detectIntents(q).length) limit = Math.min(limit, 3);
    var products = (resources.products || []).filter(isListable).slice(0, limit);

    // Products
    var prevP = shown.products, nextP = {}, counterP = { n: 0 };
    productsList.innerHTML = '';
    if (products.length) {
      productsGroup.hidden = false;
      // El aviso de «aproximados» se pintaba y la línea siguiente lo
      // machacaba con `textContent`: nunca llegó a verse. Va después.
      productsCount.textContent = String(products.length);
      if (usedFallback) {
        productsCount.insertAdjacentHTML('beforeend', ' <span class="df-search-modal__hint">· resultados aproximados</span>');
      }
      products.forEach(function (p) {
        var row = document.createElement('a');
        row.className = 'df-search-modal__product-row';
        row.setAttribute('data-df-search-result', '');
        row.href = p.url;
        var src = thumbUrl(p);
        row.innerHTML =
          (src ? '<img src="' + escapeHtml(src) + '" alt="" class="df-search-modal__product-img" loading="lazy" decoding="async" width="400" height="500">' : '<span class="df-search-modal__product-img-empty"></span>') +
          '<span class="df-search-modal__product-info">' +
            '<span class="df-search-modal__product-title">' + highlight(p.title, q) + '</span>' +
            '<span class="df-search-modal__product-meta">' +
              '<span class="df-search-modal__product-price">' + priceLabel(p) + '</span>' +
            '</span>' +
          '</span>' +
          '<span class="df-search-modal__product-cta">' + CHEVRON + '</span>';
        var isNew = tagEntry(row, keyOf(p.url), prevP, nextP, counterP);
        productsList.appendChild(row);
        if (isNew) fadeInImage(row.querySelector('img'));
      });
    } else {
      productsGroup.hidden = true;
    }
    shown.products = nextP;

    // Pages: entran detrás de los productos, no a la vez.
    var prevG = shown.pages, nextG = {}, counterG = { n: 3 };
    pagesList.innerHTML = '';
    if (pages.length) {
      pagesGroup.hidden = false;
      pages.forEach(function (p) {
        var row = document.createElement('a');
        row.className = 'df-search-modal__row';
        row.setAttribute('data-df-search-result', '');
        row.href = p.url;
        row.innerHTML = '<span>' + highlight(cleanPageTitle(p.title), q) + '</span>';
        tagEntry(row, keyOf(p.url), prevG, nextG, counterG);
        pagesList.appendChild(row);
      });
    } else {
      pagesGroup.hidden = true;
    }
    shown.pages = nextG;

    var fullUrl = fullSearchUrl(q);
    var nothing = !products.length && !pages.length && !nCollections && !nAnswers;

    // Sin nada que ofrecer: el estado vacío. Si al menos hay una respuesta o
    // una colección, eso ya es una salida y el «no encontramos» sobra.
    emptyEl.hidden = !nothing;
    if (nothing) {
      if (emptyQ) emptyQ.textContent = '«' + q + '»';
      if (emptyFull) emptyFull.href = fullUrl;
      fillEmptyTop();
    }

    // «Ver todos» solo cuando hay productos: es la puerta a la rejilla
    // completa, y sin productos esa rejilla no tiene nada mejor que ofrecer.
    seeAllEl.hidden = !products.length;
    if (seeAllLink) seeAllLink.href = fullUrl;

    helpOnRender(q, products, nCollections, nAnswers, usedFallback);
  }

  // La foto de una fila nueva aparece con un fundido cuando llega, en vez de
  // pintarse a trozos. Si ya estaba en caché (`complete`), sin fundido: no
  // hay nada que esperar.
  function fadeInImage(img) {
    if (!img || img.complete) return;
    img.classList.add('is-fading');
    var done = function () { img.classList.remove('is-fading'); };
    img.addEventListener('load', done, { once: true });
    img.addEventListener('error', done, { once: true });
  }

  // Lo más regalado, copiado de la pantalla de inicio. Una sola vez: son
  // siempre las mismas cuatro filas.
  function fillEmptyTop() {
    if (!emptyTop || emptyTop.children.length || !topList) return;
    emptyTop.innerHTML = topList.innerHTML;
    Array.prototype.forEach.call(emptyTop.querySelectorAll('a'), function (a) {
      a.setAttribute('data-df-search-result', '');
    });
  }

  // La misma búsqueda que manda el formulario al pulsar Enter, con el
  // prefijo: sin `options[prefix]=last`, «regal» no encuentra «regalo».
  function fullSearchUrl(q) {
    return '/search?q=' + encodeURIComponent(q) +
      '&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=last&type=product%2Carticle%2Cpage';
  }

  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c];
    });
  }

  // Resalta cada palabra, no la frase entera, y sin mirar tildes: antes
  // «regalo novia» no marcaba nada en «Regalos personalizados para Novia»
  // porque buscaba la cadena «regalo novia» tal cual.
  // Se busca sobre el título plegado y se corta el original por las mismas
  // posiciones; por eso hace falta que plegar no cambie la longitud, que es
  // lo que pasa con cualquier texto en NFC (é → e). Si alguna vez no cuadra,
  // se pinta sin resaltar antes que resaltar la letra equivocada.
  function highlight(text, q) {
    var src = String(text || '').normalize('NFC');
    if (!src) return '';
    var folded = stripAccents(src).toLowerCase();
    var tokens = foldTokens(q).filter(function (t) { return t.length >= 2 && !STOPWORDS[t]; });
    if (!tokens.length || folded.length !== src.length) return escapeHtml(src);

    // Solo desde el principio de una palabra, que es como busca Shopify
    // (`prefix=last`). Sin esto, «cuánto tarda el envío» pintaba el «el» de
    // «Estelar».
    var ranges = [];
    tokens.forEach(function (t) {
      var from = 0, at;
      while ((at = folded.indexOf(t, from)) !== -1) {
        if (at === 0 || !/[a-z0-9]/.test(folded.charAt(at - 1))) ranges.push([at, at + t.length]);
        from = at + t.length;
      }
    });
    if (!ranges.length) return escapeHtml(src);
    ranges.sort(function (a, b) { return a[0] - b[0]; });

    var out = '', pos = 0, i, r, end = -1, start = -1;
    for (i = 0; i <= ranges.length; i++) {
      r = ranges[i];
      if (r && r[0] <= end) { end = Math.max(end, r[1]); continue; }
      if (start !== -1) {
        out += escapeHtml(src.slice(pos, start)) + '<mark>' + escapeHtml(src.slice(start, end)) + '</mark>';
        pos = end;
      }
      if (r) { start = r[0]; end = r[1]; }
    }
    return out + escapeHtml(src.slice(pos));
  }

  var STOPWORDS = {};
  'el la los las un una unos unas de del al y o a en con por para mi mis su sus que se es lo le'.split(' ').forEach(function (w) { STOPWORDS[w] = true; });

  function toNumber(v) {
    if (typeof v === 'number') return v;
    if (v == null || v === '') return NaN;
    return parseFloat(String(v).replace(/[^\d.,]/g, '').replace(',', '.'));
  }

  function formatPrice(p) {
    if (typeof p !== 'number' || isNaN(p)) return '';
    return p.toFixed(2).replace('.', ',') + ' €';
  }

  // «desde» cuando el precio varía, igual que las filas de «Lo más regalado»
  // (`df-search-top-row`). Los cuadros van de 29,95 a 39,95 según el tamaño:
  // «29,95 €» a secas prometía un precio que no era el único.
  function priceLabel(p) {
    var min = toNumber(p.price_min != null ? p.price_min : p.price);
    var max = toNumber(p.price_max);
    var s = formatPrice(min);
    if (!s) return '';
    return (max > min ? 'desde ' : '') + s;
  }

  // La foto a 120 px (una miniatura de 56 a doble densidad). Shopify
  // devolvía el original: 459 KB por la de Donde nos Conocimos, a cada
  // búsqueda y en el móvil. Con `width` baja a 15 KB.
  function thumbUrl(p) {
    var u = p.image || (p.featured_image && p.featured_image.url) || '';
    if (!u) return '';
    // 480: la foto ya es una tarjeta de ~230 px en la rejilla, no una
    // miniatura de 56 (a 2x en una pantalla retina).
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=480';
  }

  // === RECENTS ===
  function getRecents() {
    try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); }
    catch (e) { return []; }
  }
  function saveRecent(q) {
    if (!q) return;
    var list = getRecents();
    list = list.filter(function (x) { return x !== q; });
    list.unshift(q);
    list = list.slice(0, MAX_RECENT);
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function dropRecent(q) {
    var list = getRecents().filter(function (x) { return x !== q; });
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list)); } catch (e) {}
    renderRecents();
  }
  function renderRecents() {
    if (!recentGroup || !recentChips) return;
    var list = getRecents();
    if (!list.length) {
      recentGroup.hidden = true;
      return;
    }
    recentGroup.hidden = false;
    recentChips.innerHTML = '';
    list.forEach(function (q) {
      // Ficha + aspa propia. El boton «Limpiar» de la cabecera las borra
      // todas, que es demasiado para quitarse de encima una sola busqueda
      // mal escrita. Y son dos botones hermanos, no uno dentro de otro:
      // anidarlos es HTML invalido y el navegador desmonta el interior.
      var wrap = document.createElement('span');
      wrap.className = 'df-search-modal__recent';

      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'df-chip df-search-modal__chip df-search-modal__chip--recent';
      b.setAttribute('data-df-search-suggest', q);
      b.textContent = q;

      var x = document.createElement('button');
      x.type = 'button';
      x.className = 'df-search-modal__recent-x';
      x.setAttribute('aria-label', 'Quitar "' + q + '" de recientes');
      x.innerHTML = '<svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
      x.addEventListener('click', function (ev) {
        ev.stopPropagation();
        dropRecent(q);
      });

      wrap.appendChild(b);
      wrap.appendChild(x);
      recentChips.appendChild(wrap);
    });
  }

  // === KEYBOARD NAV ===
  function onKeyDown(e) {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'Enter') return;
    // Solo lo que se ve: las respuestas rápidas viven en el DOM aunque estén
    // ocultas, y las flechas no deben pararse en un enlace invisible.
    var items = Array.prototype.filter.call(modal.querySelectorAll('[data-df-search-result]'), function (el) {
      return el.getClientRects().length > 0;
    });
    if (!items.length) return;
    var active = modal.querySelector('[data-df-search-result].is-active');
    var idx = active ? items.indexOf(active) : -1;
    if (e.key === 'ArrowDown') { e.preventDefault(); idx = Math.min(items.length - 1, idx + 1); }
    if (e.key === 'ArrowUp')   { e.preventDefault(); idx = Math.max(0, idx - 1); }
    // `click()` y no `location.href`: así pasa por el mismo sitio que el
    // ratón (guarda la reciente, mide la búsqueda) y respeta el `target` del
    // enlace de WhatsApp.
    if (e.key === 'Enter' && active && items.indexOf(active) !== -1) { e.preventDefault(); active.click(); return; }
    items.forEach(function (it) { it.classList.remove('is-active'); });
    if (items[idx]) {
      items[idx].classList.add('is-active');
      items[idx].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  }

  // ============================================================
  // «¿No das con ello?» — el buscador pregunta
  // ============================================================
  // Shopify devuelve productos para casi cualquier cosa (hasta «zzzz»), así
  // que el estado vacío casi nunca sale y quien no encuentra lo suyo se
  // queda mirando una lista que no le sirve. Aquí se adivina el atasco con
  // tres señales y, si salta alguna, el panel pregunta para quién es y qué
  // celebran, y le lleva a la colección que toca:
  //   1. Lo que sale no se parece a lo que ha escrito (ninguna palabra con
  //      chicha aparece en los títulos, ni hay colección ni respuesta).
  //   2. Ha probado tres búsquedas distintas sin tocar nada. Seguir
  //      escribiendo o borrar letras no cuenta («regalo» → «regalo para mi
  //      novia» es la misma búsqueda creciendo): solo cuando reescribe.
  //   3. Lleva 8 s quieto delante de los resultados sin tocar nada.
  // Una vez sale se queda hasta que vacía el campo o cierra el panel: que
  // aparezca y desaparezca con cada tecla sería peor que no tenerla.

  var HELP_IDLE_MS = 8000;
  var HELP_CHANGES = 3;

  // Palabras que no dicen qué busca: si solo hay esto, no hay atasco que
  // medir («regalo personalizado» saca cualquier cosa y está bien).
  var HELP_STOP = ' regalo regalos para personalizado personalizada personalizados personalizadas original originales algo quiero busco buscar unos unas como algun alguna cosa cosas especial bonito bonita mejor mucho ';

  var HELP_WHO = [
    { k: 'pareja',   label: 'Pareja',   url: '/collections/para-parejas',
      words: 'novi* pareja marido maridos espos*' },
    { k: 'mama',     label: 'Mamá',     url: '/collections/para-mama',
      words: 'mama mami madre madres' },
    { k: 'papa',     label: 'Papá',     url: '/collections/para-papa',
      words: 'papa papi padre padres' },
    { k: 'abuelos',  label: 'Abuelos',  url: '/collections/regalos-personalizados-abuelos',
      words: 'abuel* yaya yayo' },
    { k: 'amigos',   label: 'Amigo/a',  url: '/collections/regalos-personalizados-amigos',
      words: 'amig* compi* companer*' },
    { k: 'peques',   label: 'Peque',    url: '/collections/regalos-personalizados-bebes-y-ninos',
      words: 'bebe* nino* nina* hij* sobrin* peque*' },
    { k: 'familia',  label: 'Familia',  url: '/collections/regalos-para-la-familia',
      // `ti*` encendería «tienda» o «tiempo»: tío y tía, como palabra entera.
      words: 'familia* herman* primo prima tio tia' },
    { k: 'mascota',  label: 'Mascota',  url: '/collections/regalos-personalizados-para-mascotas',
      words: 'perr* gat* mascota*' }
  ];

  var HELP_OCC = {
    cumple:     { label: 'Cumpleaños' },
    aniversario:{ label: 'Aniversario',  url: '/collections/regalos-personalizados-aniversario' },
    boda:       { label: 'Boda',         url: '/collections/regalos-personalizados-boda' },
    pedida:     { label: 'Pedida de mano', url: '/collections/regalos-personalizados-pedida-de-mano' },
    nacimiento: { label: 'Nacimiento',   url: '/collections/regalos-personalizados-nacimiento' },
    bautizo:    { label: 'Bautizo',      url: '/collections/regalos-personalizados-bautizo' },
    jubilacion: { label: 'Jubilación',   url: '/collections/regalos-personalizados-jubilacion' },
    casa:       { label: 'Casa nueva',   url: '/collections/regalos-personalizados-casa-nueva' },
    graduacion: { label: 'Graduación',   url: '/collections/regalos-personalizados-graduacion' },
    madre:      { label: 'Día de la Madre', url: '/collections/dia-de-la-madre' },
    memoria:    { label: 'En su memoria', url: '/collections/laminas-en-memoria' },
    nada:       { label: 'Sin motivo' }
  };
  // Lo que se ofrece a cada uno, por lo que de verdad se le regala. El
  // cumpleaños y «sin motivo» llevan a la colección de la persona: no hay
  // cruce persona × ocasión (el filtro por etiquetas está apagado).
  var HELP_OCC_BY = {
    pareja:  ['aniversario', 'cumple', 'pedida', 'boda', 'casa', 'nada'],
    mama:    ['cumple', 'madre', 'jubilacion', 'memoria', 'nada'],
    papa:    ['cumple', 'jubilacion', 'memoria', 'nada'],
    abuelos: ['aniversario', 'cumple', 'jubilacion', 'memoria', 'nada'],
    amigos:  ['cumple', 'boda', 'graduacion', 'casa', 'nada'],
    peques:  ['nacimiento', 'bautizo', 'cumple', 'nada'],
    familia: ['aniversario', 'boda', 'casa', 'memoria', 'cumple', 'nada']
  };

  var help = {
    el: null, visible: false, clicked: false,
    tries: 0, lastQ: '', idleTimer: null, who: null
  };

  function helpContentTokens(q) {
    return foldTokens(q).filter(function (t) {
      return t.length >= 4 && HELP_STOP.indexOf(' ' + t + ' ') === -1;
    });
  }

  // ¿Alguna palabra con chicha aparece en lo que ha salido? Se compara por
  // el principio (cinco letras como mucho) para que «jubilado» case con
  // «jubilación» y «estrellas» con «estrella».
  function helpLooksRelated(q, products) {
    var want = helpContentTokens(q);
    if (!want.length) return true;
    var have = [];
    products.forEach(function (p) {
      have = have.concat(foldTokens(p.title + ' ' + (p.product_type || '') + ' ' + ((p.tags || []).join ? p.tags.join(' ') : '')));
    });
    for (var i = 0; i < want.length; i++) {
      var k = Math.min(want[i].length, 5);
      var stem = want[i].slice(0, k);
      for (var j = 0; j < have.length; j++) {
        if (have[j].length >= k && have[j].slice(0, k) === stem) return true;
      }
    }
    return false;
  }

  function helpOnRender(q, products, nCollections, nAnswers, usedFallback) {
    if (!results) return;
    var a = q.toLowerCase(), b = help.lastQ.toLowerCase();
    if (!b || (a.indexOf(b) !== 0 && b.indexOf(a) !== 0)) help.tries++;
    help.lastQ = q;
    if (help.visible) return;
    clearTimeout(help.idleTimer);
    if (help.clicked) return;

    var weak = !nCollections && !nAnswers && (usedFallback || !products.length || !helpLooksRelated(q, products));
    if (weak) return helpShow(q, 'sin_parecido');
    if (help.tries >= HELP_CHANGES) return helpShow(q, 'cambios');
    help.idleTimer = setTimeout(function () {
      if (isSearchOpen() && !help.clicked && currentQuery) helpShow(currentQuery, 'quieto');
    }, HELP_IDLE_MS);
  }

  // Tecleando no está quieto: el reloj de los 8 s se para hasta que llegue
  // la siguiente tanda de resultados.
  function helpOnInput() { clearTimeout(help.idleTimer); }

  function helpHide() {
    clearTimeout(help.idleTimer);
    help.visible = false;
    help.who = null;
    if (help.el) help.el.hidden = true;
  }

  function helpReset() {
    helpHide();
    help.clicked = false;
    help.tries = 0;
    help.lastQ = '';
  }

  function helpWhoFromQuery(q) {
    var tokens = foldTokens(q);
    for (var i = 0; i < HELP_WHO.length; i++) {
      if (matchWords(HELP_WHO[i].words, tokens)) return HELP_WHO[i];
    }
    return null;
  }

  function helpShow(q, why) {
    if (!help.el) {
      help.el = document.createElement('div');
      help.el.className = 'df-search-modal__group df-search-modal__help';
      help.el.setAttribute('data-df-search-help', '');
      help.el.setAttribute('role', 'region');
      help.el.setAttribute('aria-label', 'Te ayudo a encontrar el regalo');
      help.el.addEventListener('click', helpOnClick);
    }
    if (help.el.parentNode !== results) results.insertBefore(help.el, results.firstChild);
    help.visible = true;
    var who = helpWhoFromQuery(q);
    if (who && who.k !== 'mascota') helpStepOcc(who); else helpStepWho();
    help.el.hidden = false;
    helpTrack('mostrar', { motivo: why, busqueda: q });
  }

  function helpChip(attr, value, label, extra) {
    return '<button type="button" class="df-chip df-search-modal__chip' + (extra || '') + '" ' + attr + '="' + escapeHtml(value) + '">' + escapeHtml(label) + '</button>';
  }

  function helpStepWho() {
    help.who = null;
    help.el.innerHTML =
      '<p class="df-search-modal__help-kicker">¿No das con ello? Te ayudo:</p>' +
      '<p class="df-h df-h--24 df-search-modal__help-q">¿Para quién es?</p>' +
      '<div class="df-search-modal__chips">' +
        HELP_WHO.map(function (w) { return helpChip('data-df-help-who', w.k, w.label); }).join('') +
      '</div>';
    helpAnimate();
  }

  function helpStepOcc(who) {
    help.who = who;
    var occ = HELP_OCC_BY[who.k] || ['cumple', 'nada'];
    help.el.innerHTML =
      '<p class="df-search-modal__help-kicker">Regalo para <strong>' + escapeHtml(who.label.toLowerCase()) + '</strong>' +
        ' · <button type="button" class="df-search-modal__help-back" data-df-help-back>cambiar</button></p>' +
      '<p class="df-h df-h--24 df-search-modal__help-q">¿Qué celebráis?</p>' +
      '<div class="df-search-modal__chips">' +
        occ.map(function (k) { return helpChip('data-df-help-occ', k, HELP_OCC[k].label); }).join('') +
      '</div>' +
      '<a class="df-search-modal__help-all" href="' + who.url + '" data-df-help-all>Ver todo para ' + escapeHtml(who.label.toLowerCase()) + ' →</a>';
    helpAnimate();
  }

  function helpAnimate() {
    if (REDUCED || !help.el) return;
    help.el.classList.remove('is-in');
    void help.el.offsetWidth;
    help.el.classList.add('is-in');
  }

  function helpOnClick(e) {
    var w = e.target.closest('[data-df-help-who]');
    if (w) {
      var k = w.getAttribute('data-df-help-who');
      var who = HELP_WHO.filter(function (x) { return x.k === k; })[0];
      if (!who) return;
      helpTrack('para_quien', { para: k });
      // A la mascota no se le celebra nada: directo a su colección.
      if (!HELP_OCC_BY[k]) return helpGo(who.url, { para: k });
      return helpStepOcc(who);
    }
    if (e.target.closest('[data-df-help-back]')) return helpStepWho();
    var o = e.target.closest('[data-df-help-occ]');
    if (o && help.who) {
      var ok = o.getAttribute('data-df-help-occ');
      return helpGo((HELP_OCC[ok] && HELP_OCC[ok].url) || help.who.url, { para: help.who.k, ocasion: ok });
    }
    if (e.target.closest('[data-df-help-all]') && help.who) {
      helpTrack('ir', { para: help.who.k, ocasion: 'todo' });
    }
  }

  function helpGo(url, data) {
    helpTrack('ir', data);
    if (currentQuery) saveRecent(currentQuery);
    window.location.href = url;
  }

  // Se mide cuánta gente se atasca y a dónde la lleva la tarjeta. Cada
  // envío va envuelto: una analítica caída no puede romper la navegación.
  function helpTrack(step, data) {
    var payload = { paso: step };
    for (var key in data) payload[key] = data[key];
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('df_search_helper', payload); } catch (e) {}
    try { if (window.dataLayer) window.dataLayer.push({ event: 'df_search_helper', helper: payload }); } catch (e) {}
    try { if (window.gtag) window.gtag('event', 'df_search_helper', payload); } catch (e) {}
  }

  // === TRACKING ===
  function trackSearch(q) {
    try {
      if (window.dataLayer) window.dataLayer.push({ event: 'search', search_term: q });
      if (window.gtag) window.gtag('event', 'search', { search_term: q });
      if (window.TripleWhale && window.TripleWhale.track) window.TripleWhale.track('search', { search_term: q });
    } catch (e) {}
  }

  // ============================================================
  // Invitar a buscar
  // ============================================================
  // Buscaba el 0,26 % de las sesiones. Tres cosas para que se vea que aquí
  // hay ideas: la barra de escritorio y el campo vacío del panel van
  // escribiendo búsquedas de verdad, el panel crece desde la barra, y en
  // móvil la lupa avisa una vez.

  // Salen del informe «Búsquedas principales» de Shopify (90 días a
  // 15-10-2026), dichas como las diría alguien: «regalo novia» y «bodas de
  // oro» son las dos primeras búsquedas con intención de regalo.
  var TYPE_PHRASES = [
    'regalo para mi novia',
    'bodas de oro de mis padres',
    'mapa estelar de nuestra noche',
    'algo para los abuelos',
    'cuadro para mi mejor amiga',
    'la luna del día que nació',
    'taza con nuestra foto',
    'regalo de jubilación'
  ];
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Escribe una frase letra a letra, la deja leer y la borra; luego la
  // siguiente. `write(texto)` pinta; `setTyping(bool)` dice si está a mitad
  // de palabra (para parar el parpadeo del cursor). Devuelve { stop }.
  // Con movimiento reducido no escribe: cambia de frase cada 3 s.
  // Con `onDone`, recorre `list` una sola vez y luego lo llama.
  function typeLoop(write, setTyping, startAt, onDone, list) {
    list = list || TYPE_PHRASES;
    var i = startAt || 0, pos = 0, deleting = false, timer = null, stopped = false;
    function next() {
      i++;
      if (onDone && i >= list.length) { stopped = true; setTyping(false); onDone(); return false; }
      i = i % list.length;
      return true;
    }
    function tick() {
      if (stopped) return;
      var phrase = list[i];
      if (REDUCED) {
        write(phrase);
        timer = setTimeout(function () { if (next()) tick(); }, 3000);
        return;
      }
      if (!deleting) {
        pos++;
        write(phrase.slice(0, pos));
        setTyping(true);
        if (pos >= phrase.length) {
          deleting = true;
          setTyping(false);
          timer = setTimeout(tick, 1700);
          return;
        }
        // Un poco irregular, como quien teclea: 45–85 ms por letra.
        timer = setTimeout(tick, 45 + Math.random() * 40);
      } else {
        pos--;
        write(phrase.slice(0, pos));
        setTyping(true);
        if (pos <= 0) {
          deleting = false;
          setTyping(false);
          if (!next()) return;
          timer = setTimeout(tick, 380);
          return;
        }
        timer = setTimeout(tick, 24);
      }
    }
    timer = setTimeout(tick, 600);
    return {
      stop: function () { stopped = true; clearTimeout(timer); setTyping(false); },
      index: function () { return i; }
    };
  }

  function isSearchOpen() {
    return document.documentElement.getAttribute('data-search-open') === 'true';
  }

  // El campo vacío del panel también escribe ideas, en móvil y en
  // escritorio, hasta que la persona teclea algo. Va en el `placeholder`:
  // así no se mezcla nunca con lo que escribe ella.
  function initInputTyping() {
    if (!modal || !input) return;
    var original = input.getAttribute('placeholder') || '';
    var loop = null;
    function start() {
      if (loop || input.value) return;
      loop = typeLoop(
        function (s) { input.setAttribute('placeholder', 'Busca: ' + s); },
        function () {},
        Math.floor(Math.random() * TYPE_PHRASES.length)
      );
    }
    function stop() {
      if (!loop) return;
      loop.stop();
      loop = null;
      input.setAttribute('placeholder', original);
    }
    new MutationObserver(function () {
      if (modal.hidden) stop(); else start();
    }).observe(modal, { attributes: true, attributeFilter: ['hidden'] });
    input.addEventListener('input', function () {
      if (input.value) stop(); else if (!modal.hidden) start();
    });
  }

  // Globo que escribe una búsqueda bajo la lupa del móvil (Jorge, 15-10).
  // En escritorio salió unas horas del 16-10; ahí ya está la barra de
  // `initSearchbar`. Sale cuando alguien está mirando productos: en
  // colecciones o en resultados, tras bajar dos pantallas, justo cuando
  // reaparece la cabecera. Nunca en la ficha ni en el carrito. Dura hasta
  // 5 s, se va al tocar fuera o al volver a bajar, y al tocarlo abre el
  // buscador con esa idea escrita. Una vez por visita, y nunca si en esta
  // visita ya ha abierto el buscador.
  var BUBBLE_KEY = 'df_search_bubble';
  var USED_KEY = 'df_search_used';
  function bubbleTrack(step, idea, from) {
    var payload = { paso: step, idea: idea, origen: from };
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('df_search_bubble', payload); } catch (e) {}
    try { if (window.dataLayer) window.dataLayer.push({ event: 'df_search_bubble', bubble: payload }); } catch (e) {}
    try { if (window.gtag) window.gtag('event', 'df_search_bubble', payload); } catch (e) {}
  }
  // La idea del globo sale de lo que está mirando (Jorge, 15-10: «que sea
  // personalizada»): primero la colección o la búsqueda en pantalla (para
  // quién, qué ocasión, qué producto); si no dicen nada, su última búsqueda;
  // y si no hay nada, una al azar. Gana la primera fila que encaje, así que
  // ocasiones y productos van antes que las personas. Todas devuelven
  // productos de verdad (comprobado el 15-10 contra /search/suggest.json).
  var BUBBLE_IDEAS = [
    ['aniversario*', 'regalo de aniversario'],
    ['boda*', 'regalo de boda'],
    ['pedida', 'pedida de mano'],
    ['jubilacion*', 'regalo de jubilación'],
    ['graduacion*', 'regalo de graduación'],
    ['nacimiento* baby', 'lámina de nacimiento'],
    ['bautizo*', 'regalo de bautizo'],
    ['comunion*', 'regalo de comunión'],
    ['memoria', 'lámina en su memoria'],
    ['casa+nueva', 'cuadro casa nueva'],
    ['navidad*', 'regalo de navidad'],
    ['cumple*', 'regalo de cumpleaños'],
    ['soltera*', 'despedida de soltera'],
    ['profe*', 'regalo para profesores'],
    ['taza*', 'taza mágica con foto'],
    ['sudadera* camiseta* ropa', 'sudadera personalizada'],
    ['calcetin*', 'calcetines con foto'],
    ['botella*', 'botella personalizada'],
    ['delantal*', 'delantal personalizado'],
    ['3d', 'mapa 3d'],
    ['abuel* yaya yayo', 'cuadro para los abuelos'],
    ['mama mami madre*', 'cuadro para mamá'],
    ['papa papi padre*', 'regalo para papá'],
    ['novi* pareja* marido* espos* amor', 'mapa estelar de nuestra noche'],
    ['amig*', 'cuadro para mi mejor amiga'],
    ['bebe* nino* nina* peque*', 'lámina de nacimiento'],
    ['familia*', 'cuadro de familia'],
    ['mascota* perr* gat*', 'retrato de mi mascota']
  ];
  function bubbleIdea() {
    var here = '', q = '';
    var m = location.pathname.match(/\/collections\/([^\/?#]+)/);
    if (m) {
      var h1 = document.querySelector('main h1, h1');
      here = m[1].replace(/-/g, ' ') + ' ' + (h1 ? h1.textContent : '');
    } else {
      try { here = q = new URLSearchParams(location.search).get('q') || ''; } catch (e) {}
    }
    // En resultados no se propone lo que ya ha buscado.
    var current = foldTokens(q).join(' ');
    // El '' final apaga el «vale a medias» de `matchWords`: aquí no se teclea.
    var tokens = foldTokens(here).concat(['']);
    for (var i = 0; i < BUBBLE_IDEAS.length; i++) {
      var idea = BUBBLE_IDEAS[i][1];
      if (matchWords(BUBBLE_IDEAS[i][0], tokens) && foldTokens(idea).join(' ') !== current) {
        return { label: 'Prueba:', idea: idea, from: 'pagina' };
      }
    }
    var recents = getRecents();
    for (var j = 0; j < recents.length; j++) {
      // Las muy largas no caben en el globo y suelen ser frases a medias.
      if (recents[j] && recents[j].length <= 30 && foldTokens(recents[j]).join(' ') !== current) {
        return { label: 'Seguir con:', idea: recents[j], from: 'reciente' };
      }
    }
    return { label: 'Prueba:', idea: TYPE_PHRASES[Math.floor(Math.random() * TYPE_PHRASES.length)], from: 'azar' };
  }
  function initBubble() {
    var store;
    try { store = window.sessionStorage; store.getItem(BUBBLE_KEY); } catch (e) { return; }
    // Abrir el buscador cuenta en cualquier página, salga o no el globo.
    if (modal) {
      new MutationObserver(function () {
        if (!modal.hidden) { try { store.setItem(USED_KEY, '1'); } catch (e) {} }
      }).observe(modal, { attributes: true, attributeFilter: ['hidden'] });
    }
    var cls = document.body.classList;
    if (!cls.contains('template-collection') && !cls.contains('template-search')) return;
    if (store.getItem(BUBBLE_KEY) || store.getItem(USED_KEY)) return;
    var mq = window.matchMedia('(max-width: 990px)');
    function lupa() {
      return document.querySelector('.df-header__icon-btn--mobile-only[data-toggle-search]');
    }
    var first = lupa();
    var wrap = first && first.closest('[id^="shopify-section-"]');
    if (!wrap) return;

    var maxY = 0, bubble = null, done = false, pending = null;
    window.addEventListener('scroll', function () {
      if (window.scrollY > maxY) maxY = window.scrollY;
    }, { passive: true });

    // La cabecera de escritorio también toca sus clases a cada scroll (las
    // quita aunque no estén): este observador solo vale para móvil.
    new MutationObserver(function () {
      if (!mq.matches) return;
      if (wrap.classList.contains('df-head-off')) { clearTimeout(pending); pending = null; hide(); return; }
      if (done || bubble) return;
      if (maxY < window.innerHeight * 2) return;
      // La cabecera baja con una transición de `top`: se espera a que llegue
      // para medir la lupa en su sitio.
      clearTimeout(pending);
      pending = setTimeout(show, 380);
    }).observe(wrap, { attributes: true, attributeFilter: ['class'] });

    function show() {
      pending = null;
      if (!mq.matches || done || bubble || isSearchOpen()) return;
      var btn = lupa();
      if (!btn) return;
      if (wrap.classList.contains('df-head-off')) return;
      if (document.body.style.overflow === 'hidden') return; // menú o popup abierto
      if (store.getItem(USED_KEY)) { done = true; return; }
      var r = btn.getBoundingClientRect();
      if (!r.width || r.top < 0) return;
      done = true;
      try { store.setItem(BUBBLE_KEY, '1'); } catch (e) {}

      var pick = bubbleIdea();
      var idea = pick.idea;
      bubble = document.createElement('button');
      bubble.type = 'button';
      bubble.className = 'df-search-bubble';
      bubble.setAttribute('aria-label', 'Buscar «' + idea + '»');
      bubble.innerHTML =
        '<svg class="df-search-bubble__tail" width="24" height="16" viewBox="0 0 24 16" aria-hidden="true"><path d="M3 16C6 11 8.5 6 7 .8 12 6.5 17 11.5 23 16" fill="#fff" stroke="currentColor" stroke-width="1" stroke-linejoin="round"/></svg>' +
        '<svg class="df-search-bubble__icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>' +
        '<span class="df-search-bubble__label" aria-hidden="true">' + pick.label + '</span>' +
        '<span class="df-search-bubble__text" aria-hidden="true"></span>' +
        '<span class="df-search-bubble__caret" aria-hidden="true"></span>';
      document.body.appendChild(bubble);

      // Pegado bajo la lupa, como un bocadillo que sale de ella, sin salirse
      // de los 16 px de margen; la punta del pico está en el centro de la lupa. Se mide con la frase entera:
      // vacío es estrecho y, al escribirse, se saldría por la derecha.
      var text = bubble.querySelector('.df-search-bubble__text');
      text.textContent = idea;
      // Sin la animación de entrada (su `scale` encoge la medida) y con
      // redondeo hacia arriba: con medio píxel de menos la frase salía con «…».
      bubble.style.animation = 'none';
      var tw = Math.ceil(text.getBoundingClientRect().width) + 1;
      var w = Math.ceil(bubble.getBoundingClientRect().width) + 2;
      bubble.style.animation = '';
      text.textContent = '';
      var vw = document.documentElement.clientWidth;
      var left = Math.max(16, Math.min(r.left + r.width / 2 - 28, vw - 16 - w));
      var maxW = Math.round(vw - 16 - left);
      bubble.style.top = Math.round(r.bottom + 4) + 'px';
      bubble.style.left = Math.round(left) + 'px';
      bubble.style.maxWidth = maxW + 'px';
      // La frase no encoge por el redondeo de la caja: solo se corta si de
      // verdad no cabe en la pantalla.
      text.style.flex = 'none';
      text.style.maxWidth = Math.min(tw, tw - (w - maxW)) + 'px';
      bubble.style.setProperty('--df-tail-x', Math.round(r.left + r.width / 2 - left) + 'px');
      bubbleTrack('visto', idea, pick.from);

      var pos = 0, timer = null;
      function type() {
        pos++;
        text.textContent = idea.slice(0, pos);
        if (pos < idea.length) { timer = setTimeout(type, 45 + Math.random() * 40); return; }
        bubble.classList.add('is-typed');
        timer = setTimeout(hide, 3000);
      }
      if (REDUCED) { text.textContent = idea; bubble.classList.add('is-typed'); timer = setTimeout(hide, 5000); }
      else timer = setTimeout(type, 450);

      bubble.addEventListener('click', function () {
        bubbleTrack('toque', idea, pick.from);
        hide();
        btn.click();
        // `dondefue.js` abre el modal y enfoca el campo; la idea entra justo
        // después, con su `input`, para que busque como si la hubiera tecleado.
        setTimeout(function () {
          if (!input || !isSearchOpen()) return;
          input.value = idea;
          input.dispatchEvent(new Event('input', { bubbles: true }));
        }, 120);
      });
      function outside(e) { if (bubble && !bubble.contains(e.target)) hide(); }
      setTimeout(function () { document.addEventListener('pointerdown', outside, true); }, 0);
      bubble._clean = function () { clearTimeout(timer); document.removeEventListener('pointerdown', outside, true); };
    }

    function hide() {
      if (!bubble) return;
      var el = bubble;
      bubble = null;
      el._clean();
      el.classList.add('is-leaving');
      setTimeout(function () { el.remove(); }, REDUCED ? 0 : 220);
    }
  }

  // Barra de la cabecera de escritorio (desde 1200 px). Vive recogida en la
  // lupa y de vez en cuando se abre, escribe y se recoge (Jorge, 16-10:
  // «como antes, pero minimalista» y «que aparezca de vez en cuando, salvo
  // si está en la ficha»). Se abre:
  // - al entrar, en la primera página de la visita y luego en una de cada
  //   dos (dos ideas);
  // - al volver a subir tras bajar dos pantallas, una vez por página;
  // - tras 40 s en la página sin que se haya abierto.
  // Entre dos aperturas pasan al menos 20 s. La primera idea es la del globo
  // (la de la página o su última búsqueda) cuando la hay; luego, al azar.
  // Si se abre el buscador o cambia de pestaña a medias, se recoge.
  var BAR_PAGES_KEY = 'df_searchbar_pages';
  function initSearchbar() {
    var bar = document.querySelector('[data-df-searchbar]');
    if (!bar) return;
    var target = bar.querySelector('[data-df-type-target]');
    if (!target) return;
    if (document.body.classList.contains('template-product')) return;
    var mq = window.matchMedia('(min-width: 1200px)');

    var pages = 0;
    try {
      pages = parseInt(sessionStorage.getItem(BAR_PAGES_KEY), 10) || 0;
      sessionStorage.setItem(BAR_PAGES_KEY, String(pages + 1));
    } catch (e) {}

    var queue = [], qi = 0;
    var pick = bubbleIdea();
    if (pick.from !== 'azar') queue.push(pick.idea);
    var start = Math.floor(Math.random() * TYPE_PHRASES.length);
    for (var k = 0; k < TYPE_PHRASES.length; k++) {
      var t = TYPE_PHRASES[(start + k) % TYPE_PHRASES.length];
      if (queue.indexOf(t) < 0) queue.push(t);
    }

    var open = false, loop = null, lastAt = -Infinity, idle = null, upDone = false;
    function canRun() {
      return mq.matches && !document.hidden && !isSearchOpen() &&
        document.body.style.overflow !== 'hidden'; // menú o popup abierto
    }
    function expand(n) {
      if (open || !canRun() || Date.now() - lastAt < 20000) return false;
      open = true;
      clearTimeout(idle);
      var picks = [];
      for (var j = 0; j < n; j++) picks.push(queue[qi++ % queue.length]);
      target.textContent = '';
      bar.classList.remove('is-collapsed');
      // `typeLoop` espera 600 ms antes de la primera letra: le da tiempo a
      // la píldora a abrirse.
      loop = typeLoop(
        function (s) { target.textContent = s; },
        function (on) { bar.classList.toggle('is-typing', on); },
        0,
        collapse,
        picks
      );
      return true;
    }
    function collapse() {
      if (loop) { loop.stop(); loop = null; }
      bar.classList.remove('is-typing');
      bar.classList.add('is-collapsed');
      if (open) lastAt = Date.now();
      open = false;
      armIdle();
    }
    function armIdle() {
      clearTimeout(idle);
      idle = setTimeout(function () { if (!expand(1)) armIdle(); }, 40000);
    }
    function sync() { if (open && !canRun()) collapse(); }

    var maxY = 0, lastY = window.scrollY, up = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (y > maxY) maxY = y;
      up = y < lastY ? up + (lastY - y) : 0;
      lastY = y;
      if (!upDone && maxY >= window.innerHeight * 2 && up >= 60 && expand(1)) upDone = true;
    }, { passive: true });
    if (mq.addEventListener) mq.addEventListener('change', sync);
    document.addEventListener('visibilitychange', sync);
    new MutationObserver(sync).observe(document.documentElement, { attributes: true, attributeFilter: ['data-search-open'] });

    if (pages % 2 === 0) setTimeout(function () { if (!expand(2)) armIdle(); }, 800);
    else armIdle();
  }

  function initDiscovery() {
    initInputTyping();
    initBubble();
    initSearchbar();
  }

  function boot() {
    init();
    initDiscovery();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
